/**
 * @fileoverview POST handler for the "/engagement/canvas" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { postEngagementCanvasCacheKeys } from "./constants";
import type {
  PostEngagementCanvasProps,
  PostEngagementCanvasResult,
  PostEngagementCanvasResultErrors,
} from "./types";

export const postEngagementCanvas = reactQueryMutationAdapter(
  postEngagementCanvasCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEngagementCanvasResultErrors>()(
    ({ canvas }: PostEngagementCanvasProps): Promise<PostEngagementCanvasResult> => {
      return fetch("/engagement/canvas", "POST", canvas, undefined, {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      });
    }
  )
);
